class WallDimensions extends HTMLElement {
  constructor() {
    super();

    const widthInput = this.querySelector('#wall-width');
    const heightInput = this.querySelector('#wall-height');

    widthInput.addEventListener('keydown', this.allowOnlyNumbers);

    widthInput.addEventListener('input', () => {
      this.refreshArea();
    });

    heightInput.addEventListener('keydown', this.allowOnlyNumbers);

    heightInput.addEventListener('input', () => {
      this.refreshArea();
    });
  }

  calculateAreaM2Ceil(widthCm, heightCm) {
    const area = Number(widthCm) * Number(heightCm);
    return Math.ceil(area / 10000);
  }

  refreshArea() {
    const totalPriceQuantityInput = document.querySelector('#total-price-quantity');
    const totalPriceElement = document.querySelector('#total-price');
    const totalPriceDimensions = document.querySelector('#total-price-dimensions');
    const totalPriceDimensionsHeight = document.querySelector('#total-price-dimensions-height');
    const totalPriceDimensionsWith = document.querySelector('#total-price-dimensions-width');
    const addToCartButton = document.querySelector('#total-price-submit');
    const pricePerUnit = Number(totalPriceElement?.getAttribute('data-price-per-unit')) || 0;

    const width = this.querySelector('#wall-width').value;
    const height = this.querySelector('#wall-height').value;

    totalPriceDimensions.value = `${width} x ${height} cm`;
    totalPriceDimensionsHeight.value = height;
    totalPriceDimensionsWith.value = width;

    const areaM2 = this.calculateAreaM2Ceil(width, height);

    this.querySelector('#wall-area').innerHTML = areaM2;

    totalPriceQuantityInput.value = areaM2;

    const totalPriceWithDecimal = (Math.round(pricePerUnit * areaM2) / 100)
      .toFixed(2)
      .replace('.', ',');

    totalPriceElement.innerHTML = `€${totalPriceWithDecimal}`;

    if (areaM2 > 0) {
      addToCartButton.removeAttribute('disabled');
    } else {
      addToCartButton.setAttribute('disabled', 'disabled');
    }
  }

  allowOnlyNumbers(event) {
    if (
      event.key === '.' ||
      event.key === ',' ||
      event.key === '-' ||
      event.key === 'e' ||
      event.key === 'E' ||
      event.key === '+'
    ) {
      event.preventDefault();
      return;
    }
  }
}

customElements.define('wall-dimensions', WallDimensions);
